import React from 'react';
import { Link, matchPath  } from 'react-router-dom';
import {history} from '../routers/AppRouter';
import {connect} from 'react-redux';
import API from './api';


 
class Header extends React.Component{
    state = {
      logoUrl:'',
      facebookUrl:'',
      instaUrl:'',
      linkedinUrl:'',
      youtubeUrl:'',
      behanceUrl:'',
      pinterestUrl:'',
      twitterUrl:'',
      logoclass: 'logo',
      headerclass: 'header',
      socialGroup:false
    }
    componentWillMount(){
  
      if (location.pathname === '/'){
        this.setState({logoclass:'logo home'});
      }
      if (this.props.settingsData.dataIn){
        // if data stored on Redux
        this.setState({
          logoUrl:this.props.settingsData.logo,
          facebookUrl:this.props.settingsData.facebook,
          instaUrl:this.props.settingsData.instagram,
          linkedinUrl:this.props.settingsData.linkedin,
          youtubeUrl:this.props.settingsData.youtube,
          behanceUrl:this.props.settingsData.behance,
          pinterestUrl:this.props.settingsData.twitter,
          twitterUrl:this.props.settingsData.pinterest,
        });
      } else{
        // if data not stored on Redux try to fetch again
        API.get(`settings`)
        .then(res => {
          const settings = res.data;
          this.setState({
            logoUrl:settings.logo,
            facebookUrl:settings.facebook,
            instaUrl:settings.instagram,
            linkedinUrl:settings.linkedin,
            youtubeUrl:settings.youtube,
            behanceUrl:settings.behance,
            pinterestUrl:settings.twitter,
            twitterUrl:settings.pinterest,
          });
        });
      }
      
    }
    componentDidMount() {
      const unlisten = history.listen((location, action) => {
        if (location.pathname === '/'){
          this.setState({headerclass:'header'});

        } else if (matchPath(location.pathname, { path: '/work/:id' })){          
          isWorkDetails();
        } else if (matchPath(location.pathname, { path: '/about' })){          
          navright();
        }
         else{
          this.setState({headerclass:'header navleft'});
        }
      });
      
      const isWorkDetails = () =>{
        this.setState({headerclass:'header details'});
      }
      const navright = () =>{
        this.setState({headerclass:'header navright'});
      }
      if (location.pathname === '/'){
       
      } else if (matchPath(location.pathname, { path: '/work/:id' })){          
        isWorkDetails();
      } else if (matchPath(location.pathname, { path: '/about' })){          
        navright();
      } else{
        this.setState({headerclass:'header navleft'});
      }
        
    };

    handelSocialMobMenu = (e) =>{
      e.preventDefault();
      this.setState({
        socialGroup: !this.state.socialGroup
      });
    }

    
  render(){
    return(
      <header className={this.state.headerclass}>
        <div className="bContainer">
          <div className="col-in-6">     
            <Link to={{pathname: '/', state: { prevPath: location.pathname }}}><img ref="logo" id="logo" className={this.state.logoclass} src={this.state.logoUrl} alt="Logo" /></Link>
          </div>
          <div className="col-in-6">
            <div className="rightNav">
              <span className={`socialGroup ${this.state.socialGroup ? "on" : ""}`}>
                {/*this.state.facebookUrl && <a className="button socialIcon" href={this.state.facebookUrl} target="_blank"><span className="icon-facebook"></span></a>*/}
                {/*this.state.instaUrl && <a className="button socialIcon" href={this.state.instaUrl} target="_blank"><span className="icon-instagram"></span></a>*/}
                {this.state.linkedinUrl && <a className="button socialIcon" href={this.state.linkedinUrl} target="_blank"><span className="icon-linkedin"></span></a>}
                {this.state.youtubeUrl && <a className="button socialIcon" href={this.state.youtubeUrl} target="_blank"><span className="icon-youtube-play"></span></a>}
                {this.state.behanceUrl && <a className="button socialIcon" href={this.state.behanceUrl} target="_blank"><span className="icon-behance"></span></a>}
                {this.state.pinterestUrl && <a className="button socialIcon" href={this.state.pinterestUrl} target="_blank"><span className="icon-pinterest-p"></span></a>}
                {this.state.twitterUrl && <a className="button socialIcon" href={this.state.twitterUrl} target="_blank"><span className="icon-twitter"></span></a>}
                
              </span>
              <a onClick={this.handelSocialMobMenu} className="button socialIcon hidden-sm hidden-md hidden-lg" href="#" target="_blank"><span className="icon-ellipsis-h"></span></a>
              <a className="button socialIcon telPc hidden-sm hidden-md hidden-lg" href="tel:00201223820616"><span className="icon-phone"></span></a>
              
              <Link className="button socialIcon  hidden-xs" to={{pathname: 'contact', state: { prevPath: location.pathname }}}><span className="icon-phone"></span></Link>
              <Link className="button socialIcon" to={{pathname: 'contact', state: { prevPath: location.pathname }}}><span className="icon-at"></span></Link>
            </div>
          </div>
        </div>
      </header>
    );
  }
}


const mapStateToProps = (state) =>{
  return{
    settingsData: state.settings
  };
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js